import axios from 'axios'

export default {
  namespaced: true,
  actions: {
    getCollaborators(_, { params = {} } = {}) {
      return new Promise((resolve, reject) => {
        axios({
          url: `${process.env.VUE_APP_URL}/sa/web/list`,
          method: 'GET',
          params
        }).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      });
    },
    createCollaborators(_, data) {
      return axios({
        url: process.env.VUE_APP_URL + "/sa/web",
        method: "POST",
        data,
      });
    },
    editCollaborators(_, superAdminId, data) {
      return axios({
        url: process.env.VUE_APP_URL + `/sa/web/${superAdminId}`,
        method: "PUT",
        data,
      });
    },
    sendWelcomeEmailToCollaborators(_, data) {
      return axios({
        url: process.env.VUE_APP_URL + "/sa/web/resendWelcome",
        method: "POST",
        data,
      });
    },
    deleteCollaborators(_, data) {
      return axios({
        url: process.env.VUE_APP_URL + "/sa/web",
        method: "DELETE",
        data,
      })
    },
  }
}